import { stylesCSS } from "./styles-css";
export function initialHTML() {
    const container = document.querySelector(".people-groups");
    container.innerHTML = `
        ${stylesCSS()}
        <ul class="group-cta-list">
            <li class="input">
                <input disabled="disabled" placeholder="Search people & groups" id="group-search" />
            </li>
            <li>
                <a title="View the online directory" class="group-cta-list__cta"
                href="https://www.cedarparkchurchofchrist.org/members/directory">
                    <span class="fa-solid fa-address-book"></span>
                </a>
            </li>
            <li>
                <a title="View the member map" class="group-cta-list__cta"
                href="https://www.cedarparkchurchofchrist.org/members/member-map">
                    <span class="fa-solid fa-location-dot"></span>
                </a>
            </li>
            <li>
                <a title="View the internal calendar" class="group-cta-list__cta"
                href="https://www.cedarparkchurchofchrist.org/members/internal-calendar">
                    <span class="fa-solid fa-calendar-days"></span>
                </a>
            </li>
            <li>
                <button title="Print this page" class="group-cta-list__cta" onClick="window.print();">
                    <span class="fa-solid fa-print" aria-hidden="true"></span>
                </button>
            </li>
        </ul>
        <div class="groups-row">
            <div class="loading"><span class="fa-solid fa-spinner fa-spin"></span>
                <p>Hang tight, we're gathering the people together.</p>
            </div>
        </div>
        <article class="group-details">
            <div class="container">
                <button class="group-details__close" title="Close">
                    <span class="fa-solid fa-xmark"></span>
                </button>
                <h1 class="title"></h1>
                <section class="group-stats"></section>
                <section class="group-leaders"></section>
                <section class="group-email__section">
                    <h4>Group Email</h4>
                    <input class="group-email" disabled="disabled" />
                </section>
                <section class="individual-emails__section">
                    <h4>Member Email List</h4>
                    <textarea class="individual-emails" disabled="disabled"></textarea>
                </section>
            </div>
            <div class="group-details__background"></div>
        </article>
    `;
}
